import './NotFound.css';

function NotFound(){
    return (
    <div className='NotFound'>
        <h1 style={{color: 'white'}}>404 - Page Not Found</h1>
        <p style={{color: 'white'}}>The page you are looking for does not exist.</p>
    </div>
    );
};

export default NotFound;

